<template>
  <div
    style="border-bottom: 1px solid #262626;height:1px;max-width: 90%;margin: 30px auto;"
  ></div>
</template>

<script>

export default {
  name: 'UserFormPageBreak',
  props: ['userFormId', 'section'],
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>